<template>
    <div :class="{ hidden: !loading}">
        <loading></loading>
    </div>
    <div class="max-w-md" :class="{ hidden: loading}">
        <form action="" class="form form--floating-label" @submit.prevent="formSubmit" ref='form' >
            <div class="style-emph mb-4">
                Account Details
            </div>

            <div class="mb-5">
                <div class="input-container input-container--floating relative h-12" :class="{empty: !formData.name, error: submittedOnce && errors.name}">
                    <input
                            id="account-name"
                            type="text"
                            v-model="formData.name"
                            class="h-full w-full px-2 transition-all border-blue-gray rounded text-blue"
                    />
                    <label for="account-name" class="absolute left-2 transition-all px-1 text-blue-gray">
                        Account Name
                    </label>
                </div>

                <div v-if="submittedOnce && errors.name " class="text-red text-sm mt-2 leading-none">
                    {{ errors.name }}
                </div>
            </div>

            <div class="mb-5">
                <div class="input-container input-container--floating relative h-12" :class="{empty: !formData.account_number, error: submittedOnce && errors.account_number}">
                    <input
                            id="account-number"
                            type="text"
                            v-model="formData.account_number"
                            class="h-full w-full px-2 transition-all border-blue-gray rounded text-blue "
                    />
                    <label for="account-number" class="absolute left-2 transition-all px-1 text-blue-gray">
                        Account Number
                    </label>
                </div>

                <div v-if="submittedOnce && errors.account_number " class="text-red text-sm mt-2 leading-none">
                    {{ errors.account_number }}
                </div>
            </div>

            <div class="mb-5">
                <div class="input-container input-container--floating relative h-12 " :class="{empty: !formData.group_id && !formData.group_name, error: submittedOnce && errors.group_id}">
                    <autocomplete
                            :options="clientGroups"
                            :selected="formData.group_id"
                            @update:selected="formData.group_id = $event"
                            @update:text="formData.group_name = $event"
                            :label="'Assigned Group'"></autocomplete>
                </div>

                <div class="style-body font-sm mt-1" :class="{hidden: formData.group_id != -1}">
                    New Client Group
                </div>

                <div v-if="submittedOnce && errors.group_id " class="text-red text-sm mt-2 leading-none">
                    {{ errors.group_id }}
                </div>
            </div>

            <div v-if="success" class="bg-blue-success text-white mb-5 px-3 py-2 rounded ">
                {{ success }}
            </div>

            <div v-if="errors.message" class="bg-red text-white mb-5 px-3 py-2 rounded ">
                {{ errors.message }}
            </div>

            <div class="mt-10 flex flex-col md:flex-row items-center gap-x-8 gap-y-3">
                <button type="submit" class="btn w-full md:w-auto">Save Client</button>

                <span v-if="this.selectedClient.id" @click="goToClientUsers" class="btn btn--gray-outline w-full md:w-auto">View Users</span>
                <a
                        @click="$router.go(-1)"
                        class="mt-3 md:mt-0 text-red hover:text-red-hover font-light underline cursor-pointer">Go Back</a>
            </div>


        </form>
    </div>
</template>

<script charset="utf-8">
    import { values, join, get } from 'lodash';
    import Loading from '../includes/Loading.vue';
    import Autocomplete from "../includes/Autocomplete.vue";

    import Vuex from 'vuex';

    export default {
        name: 'ClientForm',
        props: ['clientID'],
        data() {
            return {
                formData: {
                    id: null,
                    name: '',
                    group_id: '',
                    group_name: '',
                    account_number: ''
                },
                loading: false,
                submittedOnce: false,

                success: '',
                errors: {
                    name: 'Client name is required',
                    //group_id: 'Client group is required',
                    account_number: 'Account number is required',
                    message: ''
                }
            }
        },

        components: {
            Loading,
            Autocomplete
        },

        emits: ["submit-success"],

        computed: {
            ...Vuex.mapGetters('profile', {
                profile: 'profile'
            }),
            ...Vuex.mapGetters('accounts', {
                clientGroups: 'clientGroups',
                selectedClient: 'selectedClient'
            }),
        },

        watch: {
            formData: {
                handler(newVal){
                    this.errors.message = '';

                    this.errors.name = newVal.name ? '' : 'Client name is required';
                    //this.errors.group_id   = (newVal.group_id || newVal.group_name)  ? '' : 'Client group is required';
                    this.errors.account_number   = newVal.account_number  ? '' : 'Account number is required';
                },
                deep: true
            }
        },

        created() {
            this.getClientGroups();

            if(this.clientID){
                this.loading = true;
                this.getClient({clientID: this.clientID}).then((res) => {
                    this.formData.id = res.id;
                    this.formData.name = res.name;
                    this.formData.group_id = res.group_id;
                    this.formData.account_number = res.account_number;
                    this.loading = false;
                });
            }else{
                this.setEmptyClient();
            }
        },

        methods: {
            /*...Vuex.mapMutations('accounts', {
                setSelectedClient: 'setSelectedClient',
            }),*/

            ...Vuex.mapActions('accounts', {
                reloadClientGroups: 'reloadClientGroups',
                getClientGroups: 'getClientGroups',
                getClient: 'getClient',
                setEmptyClient: 'setEmptyClient',
                updateClient: 'updateClient',
            }),

            ...Vuex.mapActions('layout', {
                setPaths: 'setPaths'
            }),

            getItems(items){
                console.log(items);
            },
            formSubmit() {
                this.submittedOnce = true;
                this.errors.message = '';
                // do not submit if form has errors
                if (join(values(this.errors), '')) {
                    return;
                }
                let data = {
                    name: this.formData.name,
                    group_id: this.formData.group_id,
                    group_name: this.formData.group_name,
                    account_number: this.formData.account_number,
                };

                if(this.formData.id){
                    data.id = parseInt(this.formData.id);
                }

                this.loading = true;
                this.updateClient(data).then((res) =>{
                    this.loading = false;
                    this.success = 'Client has been saved successfully';
                    if(!this.formData.id){
                        this.success = 'Client has been created successfully';
                        this.formData.id = res.id;
                        this.formData.name = res.name;
                        this.formData.group_id = res.group_id;
                        this.formData.account_number = res.account_number;
                    }
                    if(data.group_id == -1){
                        this.reloadClientGroups();
                    }
                }).catch(err => {
                    this.loading = false;
                    this.errors = {
                        name: get(err, 'response.data.errors.name[0]'),
                        group_name: get(err, 'response.data.errors.group_name[0]'),
                        account_number: get(err, 'response.data.errors.account_number[0]'),
                        message: 'Invalid data'
                    }
                });
            },
            goToClientUsers(){
                if(this.profile.isGroupAdmin()){
                    this.$router.push({ name: 'groupAdminUser', params: { clientID: this.selectedClient.id } });
                }else{
                    this.$router.push({ name: 'adminUser', params: { clientID: this.selectedClient.id } });
                }
            },
        }
    }
</script>
